import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  HttpErrorResponse,
  type HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REFRESH_TOKEN_ERROR } from '@ellf/common-utils';
import { NgrxErrorFacade } from './+state/ngrx-error.facade';
import { ErrorConfig } from './error.config';

export const SKIP_INTERCEPT_HEADER = 'skip-intercept-on-error';
@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  constructor(
    private facade: NgrxErrorFacade,
    private config: ErrorConfig,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      request.headers.get(SKIP_INTERCEPT_HEADER) != null ||
      !request.url.includes(this.config.apiEndpoint)
    ) {
      const newHeaders = request.headers.delete(SKIP_INTERCEPT_HEADER);
      const newRequest = request.clone({ headers: newHeaders });
      return next.handle(newRequest);
    }

    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401 && !request.url.includes('auth/sign-in')) {
            // Expired token error, do not intercept, let the error go
            return throwError(() => error);
          } else if (error.error) {
            // MANAGE ERRORS
            if (typeof error.error === 'string') {
              // client-side error
              errorMessage = `${error.error}`;
              this.facade.addApiErrorMessage(errorMessage, error.status);
            } else if (error instanceof ArrayBuffer) {
              return throwError(() => error);
            } else {
              let err = error.error;
              if (error.error instanceof ArrayBuffer) {
                try {
                  err = JSON.parse(
                    new TextDecoder().decode(new Uint8Array(error.error)),
                  );
                } catch {
                  errorMessage = new TextDecoder().decode(
                    new Uint8Array(error.error),
                  );
                  this.facade.addApiErrorMessage(errorMessage, error.status);
                  return throwError(() => new Error(errorMessage));
                }
              }
              // server-side error
              if (err.message) {
                errorMessage = err.message;
              } else if (error.message) {
                errorMessage = error.message;
              } else if (error.status === 0) {
                errorMessage = `Network error, check your internet connection.`;
              } else {
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
              }

              if (
                error.status !== 403 ||
                errorMessage !== REFRESH_TOKEN_ERROR
              ) {
                this.facade.addApiErrorMessage(errorMessage, error.status);
              }
            }
          }
        }
        return throwError(() => new Error(errorMessage));
      }),
    );
  }
}
